import React from "react";
import PropTypes from "prop-types";

import FilterItem from "@javascript/reactComponents/lds/FilterItem";
import Icon from "@javascript/reactComponents/lds/Icon";

const EntitySearchFilterItem = ({
  eventCount,
  itemName,
  leadingContent,
  onClick = () => {},
  tooltip,
}) => {
  const handleWholeItemClick = (event) => {
    event.stopPropagation();
    $("body").addClass("wait");
    onClick(itemName);
  }

  const trailingContent = (
    <>
      <span>{eventCount && eventCount !== "0" && commifyNumber(eventCount)}</span>
    </>
  );

  return (
    <FilterItem
      label={itemName}
      leadingContent={leadingContent}
      onWholeItemClick={handleWholeItemClick}
      tooltip={tooltip}
      trailingContent={trailingContent}
    />
  );
};

EntitySearchFilterItem.propTypes = {
  eventCount: PropTypes.number,
  itemName: PropTypes.string.isRequired,
  leadingContent: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.oneOf([null])
  ]),
  onClick: PropTypes.func,
  tooltip: PropTypes.string,
};

export default EntitySearchFilterItem;
